<template>
  <div>
    <h3 class="title">Diabetes Risk Test</h3>
    <ul class="topiclist">
      <li>
        1. อายุ <input class="input" type="integer" v-model="age" size="3px" />ปี
        ({{ p1 }} point)
      </li>
      <li>
        2. เพศ <br /><input class="input" type="radio" v-model="sex" value="m" />
        <label for="male">Man</label>
        <input type="radio" v-model="sex" value="f" />
        <label for="female">Woman</label>({{ p2 }} point)
      </li>

      <li>
        3. เคยเป็น Gestational Diabetes Mellitus (GDM)
        <br />
        <input v-if="sex === 'm' " class="input" type="radio" v-model="gdm" value="y" disabled/>
        <input v-else class="input" type="radio" v-model="gdm" value="y" />
        <label for="yes">Yes</label>
        <input type="radio" v-model="gdm" value="n" />
        <label for="no">No</label>({{ p3 }} point)
      </li>
      <li>
        4. มี บิดา มารดา หรือพี่น้องเป็น DM
        <br />
        <input class="input" type="radio" v-model="fh" value="y" />
        <label for="yes">Yes</label>
        <input type="radio" v-model="fh" value="n" />
        <label for="no">No</label>({{ p4 }} point)
      </li>
      <li>
        5. เคยถูกวินิจฉัยว่ามีภาวะความดันโลหิตสูง
        <br />
        <input class="input" type="radio" v-model="hbp" value="y" />
        <label for="yes">Yes</label>
        <input type="radio" v-model="hbp" value="n" />
        <label for="no">No</label>({{ p5 }} point)
      </li>
      <li>
        6. เป็นคนแอคทีฟ (Are you physically active?)
        <br />
        <input class="input" type="radio" v-model="pa" value="y" />
        <label for="yes">Yes</label>
        <input type="radio" v-model="pa" value="n" />
        <label for="no">No</label>({{ p6 }} point)
      </li>
      <li>
        7. ส่วนสูง
        <input class="input" type="integer" v-model="height" size="5px" />
        เซนติเมตร ({{ hcon }}) 
      </li>
      <li>
        น้ำหนัก<input
          class="input"
          type="integer"
          v-model="weight"
          size="5px"
        />
        กิโลกรัม ({{ wilbscalc }} lbs) ({{ p7 }} point) <br />
        <span v-show=" hiicalc < 58 " class="desc"
      >ไม่สามารถประเมินความเสี่ยงข้อนี้ได้เนื่องจากคุณมีส่วนสูงอยู่นอกช่วงงานวิจัย</span>
       <span v-show=" hiicalc >= 77 " class="desc"
      >ไม่สามารถประเมินความเสี่ยงข้อนี้ได้เนื่องจากคุณมีส่วนสูงอยู่นอกช่วงงานวิจัย</span>
      </li>
      
    </ul>

    <div id="normal" v-show="sump <= 4">
      ยังไม่มีความเสี่ยง ({{ sump }} point)
    </div>
    <div id="warning" v-show="sump > 4">
      มีความเสี่ยงต่อการเกิดโรคเบาหวานสูงกว่าปรกติ ({{ sump }} point) <br />
      ควรปรึกษาแพทย์เพื่อตรวจคัดกรองหาโรคเบาหวาน คัดกรองหาภาวะก่อนเบาหวาน
      <a href="https://www.facebook.com/medicine4layman/posts/2795071100808905"
        >หรือปฏิบัติตัวเพื่อชะลอโรคเบาหวาน</a
      >
    </div>
    <br />

    <b>Reference</b>
    <ul id="ref">
      <li>
        <a
          href="https://care.diabetesjournals.org/content/44/Supplement_1/S15.figures-only"
          >Classification and Diagnosis of Diabetes: Standards of Medical Care
          in Diabetes—2021</a
        >
      </li>
      <li>
        <a
          href="https://www.facebook.com/medicine4layman/posts/2795226354126713"
          >เพจอายุรศาสตร์ ง่ายนิดเดียว</a
        >
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "dm2rt",
  data() {
    return {
      age: 35,
      sex: "f",
      gdm: "n",
      fh: "n",
      hbp: "n",
      pa: "y",
      height: 160,
      weight: 60,
    };
  },
  computed: {
    hiicalc() {
      return Math.round(this.height / 2.54);
    },
    wilbscalc() {
      return Math.round(this.weight * 2.205);
    },
    hcon() {
      return (
        Math.floor(this.height / 2.54 / 12) +
        " ft " +
        Math.round((this.height / 2.54) % 12) +
        " in"
      );
    },
    p1() {
      if (this.age < 40) {
        return 0;
      } else if (this.age < 50) {
        return 1;
      } else if (this.age < 60) {
        return 2;
      } else {
        return 3;
      }
    },
    p2() {
      if (this.sex == "m") {
        return 1;
      } else {
        return 0;
      }
    },
    p3() {
      if (this.gdm == "y") {
        return 1;
      } else {
        return 0;
      }
    },
    p4() {
      if (this.fh == "y") {
        return 1;
      } else {
        return 0;
      }
    },
    p5() {
      if (this.hbp == "y") {
        return 1;
      } else {
        return 0;
      }
    },
    p6() {
      if (this.pa == "n") {
        return 1;
      } else {
        return 0;
      }
    },
    p7() {
      if (this.hiicalc < 58) {
        return 0;
      } else if (this.hiicalc < 59) {
        if (this.wilbscalc < 119) {
          return 0;
        } else if (this.wilbscalc < 143) {
          return 1;
        } else if (this.wilbscalc < 191) {
          return 2;
        } else {
          return 3;
        }
      } else if (this.hiicalc < 60) {
        if (this.wilbscalc < 124) {
          return 0;
        } else if (this.wilbscalc < 148) {
          return 1;
        } else if (this.wilbscalc < 198) {
          return 2;
        } else {
          return 3;
        }
      } else if (this.hiicalc < 61) {
        if (this.wilbscalc < 128) {
          return 0;
        } else if (this.wilbscalc < 153) {
          return 1;
        } else if (this.wilbscalc < 204) {
          return 2;
        } else {
          return 3;
        }
      } else if (this.hiicalc < 62) {
        if (this.wilbscalc < 132) {
          return 0;
        } else if (this.wilbscalc < 158) {
          return 1;
        } else if (this.wilbscalc < 211) {
          return 2;
        } else {
          return 3;
        }
      } else if (this.hiicalc < 63) {
        if (this.wilbscalc < 136) {
          return 0;
        } else if (this.wilbscalc < 164) {
          return 1;
        } else if (this.wilbscalc < 218) {
          return 2;
        } else {
          return 3;
        }
      } else if (this.hiicalc < 64) {
        if (this.wilbscalc < 141) {
          return 0;
        } else if (this.wilbscalc < 169) {
          return 1;
        } else if (this.wilbscalc < 225) {
          return 2;
        } else {
          return 3;
        }
      } else if (this.hiicalc < 65) {
        if (this.wilbscalc < 145) {
          return 0;
        } else if (this.wilbscalc < 174) {
          return 1;
        } else if (this.wilbscalc < 232) {
          return 2;
        } else {
          return 3;
        }
      } else if (this.hiicalc < 66) {
        if (this.wilbscalc < 150) {
          return 0;
        } else if (this.wilbscalc < 180) {
          return 1;
        } else if (this.wilbscalc < 240) {
          return 2;
        } else {
          return 3;
        }
      } else if (this.hiicalc < 67) {
        if (this.wilbscalc < 155) {
          return 0;
        } else if (this.wilbscalc < 186) {
          return 1;
        } else if (this.wilbscalc < 247) {
          return 2;
        } else {
          return 3;
        }
      } else if (this.hiicalc < 68) {
        if (this.wilbscalc < 159) {
          return 0;
        } else if (this.wilbscalc < 191) {
          return 1;
        } else if (this.wilbscalc < 255) {
          return 2;
        } else {
          return 3;
        }
      } else if (this.hiicalc < 69) {
        if (this.wilbscalc < 164) {
          return 0;
        } else if (this.wilbscalc < 197) {
          return 1;
        } else if (this.wilbscalc < 262) {
          return 2;
        } else {
          return 3;
        }
      } else if (this.hiicalc < 70) {
        if (this.wilbscalc < 169) {
          return 0;
        } else if (this.wilbscalc < 203) {
          return 1;
        } else if (this.wilbscalc < 270) {
          return 2;
        } else {
          return 3;
        }
      } else if (this.hiicalc < 71) {
        if (this.wilbscalc < 174) {
          return 0;
        } else if (this.wilbscalc < 209) {
          return 1;
        } else if (this.wilbscalc < 278) {
          return 2;
        } else {
          return 3;
        }
      } else if (this.hiicalc < 72) {
        if (this.wilbscalc < 179) {
          return 0;
        } else if (this.wilbscalc < 215) {
          return 1;
        } else if (this.wilbscalc < 286) {
          return 2;
        } else {
          return 3;
        }
      } else if (this.hiicalc < 73) {
        if (this.wilbscalc < 184) {
          return 0;
        } else if (this.wilbscalc < 221) {
          return 1;
        } else if (this.wilbscalc < 294) {
          return 2;
        } else {
          return 3;
        }
      } else if (this.hiicalc < 74) {
        if (this.wilbscalc < 189) {
          return 0;
        } else if (this.wilbscalc < 227) {
          return 1;
        } else if (this.wilbscalc < 302) {
          return 2;
        } else {
          return 3;
        }
      } else if (this.hiicalc < 75) {
        if (this.wilbscalc < 194) {
          return 0;
        } else if (this.wilbscalc < 233) {
          return 1;
        } else if (this.wilbscalc < 311) {
          return 2;
        } else {
          return 3;
        }
      } else if (this.hiicalc < 76) {
        if (this.wilbscalc < 200) {
          return 0;
        } else if (this.wilbscalc < 240) {
          return 1;
        } else if (this.wilbscalc < 319) {
          return 2;
        } else {
          return 3;
        }
      } else if (this.hiicalc < 77) {
        if (this.wilbscalc < 205) {
          return 0;
        } else if (this.wilbscalc < 246) {
          return 1;
        } else if (this.wilbscalc < 328) {
          return 2;
        } else {
          return 3;
        }
      } else {
        return 0;
      }
    },
    sump() {
      return (
        this.p1 + this.p2 + this.p3 + this.p4 + this.p5 + this.p6 + this.p7
      );
    },
  },
};
</script>

<style scoped>

</style>
